const faqMain = {
  title: 'Поширені запитання',
  faqs: {
    aboutProduct: {
      title: '/ Про продукт',
      questions: {
        q1: {
          question: 'ЧИ СЕРТИФІКОВАНИЙ ДРОН PEGASUS ARMS 25?',
          answer:
            'Так. Pegasus Arms 25 кодифікований (допущений до експлуатації) Міністерством оборони України та внесений до офіційного переліку рекомендованих БпЛА. Це дозволяє проводити закупівлі через державні структури, волонтерські фонди, військові частини, міські ради, цільові кошти.',
        },
        q2: {
          question: 'ЯКІ ОСНОВНІ ХАРАКТЕРИСТИКИ ДРОНУ?',
          answer: [
            'Корисне навантаження: до 14 кг',
            'Тривалість польоту: до 45 хв',
            'Радіус звязку: до 30 км',
            'Максимальна швидкість: до 110 км/год',
            'Протидія РЕБ: ППРЧ (стійкий)',
            'Вітростійкість : до 20 м/с',
            'Багаторазове використання',
          ],
        },
      },
    },
    manufacturing: {
      title: '/ Виготовлення та обслуговування',
      questions: {
        q1: {
          question: 'СКІЛЬКИ ЧАСУ ЗАЙМАЄ ВИГОТОВЛЕННЯ ОДНОГО КОМПЛЕКСУ?',
          answer:
            'Стандартний термін виготовлення 7-14 днів. Можливі пріоритетні поставки за терміновою потребою Сил оборони.',
        },
        q2: {
          question: 'ЧИ НАДАЄ КОМПАНІЯ СЕРВІСНЕ ОБСЛУГОВУВАННЯ?',
          answer:
            'Так. Компанія надає сервісну та технічну підтримку 24/7, а також консультації, ремонт, оновлення програмного забезпечення протягом 12 місяців. Важлива умова – наявність сертифікату проходження навчання на оператора БпЛА.',
        },
      },
    },
    training: {
      title: '/ навчання та Застосування',
      questions: {
        q1: {
          question: 'ЧИ ПРОВОДИТЬ КОМПАНІЯ НАВЧАННЯ ОПЕРАТОРІВ БПЛА?',
          answer:
            'Так. Ми, як виробник, забезпечуємо повний цикл підготовки операторів БпЛА/БпАК: від теорії до практичних польотів. Також співпрацюємо з партнерами, які мають можливість навчати на БпЛА Pegasus Arms 25 БпЛА – це Сили ТРО, ОБр ТрО, сухопутні війська. Навчання проводять фахівці з бойовим досвідом.',
        },
        q2: {
          question: 'ДЕ ВЖЕ ВИКОРИСТОВУЮТЬСЯ ДРОНИ PEGASUS ARMS 25?',
          answer:
            'Дрони активно застосовуються підрозділами Сил оборони по всій лінії бойового зіткнення. Загалом вже більше 50 бригад щодня використовують наші БпЛА на передовій.',
        },
      },
    },
    order: {
      title: '/ замовлення та Підтримка',
      questions: {
        q1: {
          question: 'ЧИ МОЖНА ЗАМОВИТИ ДРОН ЯК ВОЛОНТЕР ЧИ ФОНД?',
          answer:
            'Так. Також ми укладаємо прямі контракти з військовими частинами, державними адміністраціями.',
        },
        q2: {
          question: 'ЯК ОТРИМАТИ КОНСУЛЬТАЦІЮ СПЕЦІАЛІСТА?',
          answer:
            'Заповніть форму на сайті або напишіть запит на офіційну пошту компанії p.info@pegasusarms.com',
        },
      },
    },
  },
}
export default faqMain
